const skills = [
    {
        name: 'HTML',
        percentage: '90'
    },
    {
        name: 'CSS',
        percentage: '85'
    },
    {
        name: 'JS',
        percentage: '80'
    },
    {
        name: 'Vue Js',
        percentage: '80'
    },
    {
        name: 'React Js',
        percentage: '70'
    },
    {
        name: 'Laravel',
        percentage: '65'
    },
    {
        name: 'Node Js',
        percentage: '65'
    },
    {
        name: 'Ruby',
        percentage: '50'
    },
    {
        name: 'MySQL',
        percentage: '50'
    },
    {
        name: 'Docker',
        percentage: '30'
    }

]

export default skills